import { type ReactNode } from 'react';

type RecordDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  eyebrow: string;
  title: string;
  children: ReactNode;
};

export function RecordDrawer({ isOpen, onClose, eyebrow, title, children }: RecordDrawerProps) {
  if (!isOpen) return null;
  return (
    <>
      <div className="drawer-scrim is-open" onClick={onClose} aria-hidden="true" />
      <aside className="record-drawer is-open" role="dialog" aria-modal="true" aria-label={title}>
        <div className="record-drawer__header">
          <div>
            <span className="eyebrow">{eyebrow}</span>
            <h2>{title}</h2>
          </div>
          <button className="button" type="button" onClick={onClose} aria-label="Close drawer">
            Close
          </button>
        </div>
        <div className="record-drawer__body">
          {children}
        </div>
      </aside>
    </>
  );
}
